<div class="newsletter-panel">
    <vb-panel-header
        title="Newsletter"
        subtitle="Manage your monthly newsletter subscription."></vb-panel-header>

    <div class="newsletter-panel__card">
        <vb-newsletter-subscription-form></vb-newsletter-subscription-form>
    </div>
</div>
